export class SaveNotebookContentRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "content",
            "baseName": "content",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaveNotebookContentRequest.attributeTypeMap;
    }
    constructor() {
    }
}
